import { defineComponent as _defineComponent } from 'vue'
import BasketEmpty from '@/ui/views/checkout/BasketEmpty.vue';
import BasketSummaryB2B from '@/ui/views/checkout/BasketSummaryB2B.vue';
import BasketOrderReferenceB2B from '@/ui/views/checkout/BasketOrderReferenceB2B.vue';
import BasketDeliveryTypeB2B from '@/ui/views/checkout/BasketDeliveryTypeB2B.vue';
import PaymentMethodsB2B from '@/ui/views/checkout/PaymentMethodsB2B.vue';
import CheckoutButtonB2B from '@/ui/views/checkout/CheckoutButtonB2B.vue';
import { store } from '@/store';
import { parse } from 'date-fns';
import { SiteMode } from './site-mode';
import { internalDateFormat } from '@/core/constants';
import BasketLineItemsB2B from '@/ui/views/checkout/BasketLineItemsB2B.vue';
import BasketTitle from '@/ui/views/checkout/BasketTitle.vue';
import BasketAddressSelectorB2B from '@/ui/views/checkout/BasketAddressSelectorB2B.vue';
import UpdateOrderReferenceWebRequest = Vertica.LouisPoulsen.Application.Commerce.Requests.UpdateOrderReferenceWebRequest;
import UpdatePaymentMethodWebRequest = Vertica.LouisPoulsen.Application.Commerce.Requests.UpdatePaymentMethodWebRequest;
import BasketViewModel = Vertica.LouisPoulsen.Application.Commerce.ViewModels.Business.BasketViewModel;
import UpdateOrderDeliveryTypeWebRequest = Vertica.LouisPoulsen.Application.Commerce.Requests.UpdateOrderDeliveryTypeWebRequest;
import UpdateOrderDeliveryDateWebRequest = Vertica.LouisPoulsen.Application.Commerce.Requests.UpdateOrderDeliveryDateWebRequest;
import ValidationResultViewModel = Vertica.LouisPoulsen.Application.Commerce.ViewModels.ValidationResultViewModel;
import SaveCheckoutViewModel = Vertica.LouisPoulsen.Application.Commerce.ViewModels.Business.SaveCheckoutViewModel;
import BasketPageViewModel = Vertica.LouisPoulsen.Application.Content.Pages.Basket.Business.BasketPageViewModel;
import CustomDeliveryAddressViewObject = Vertica.LouisPoulsen.Application.Commerce.ViewModels.Business.CustomDeliveryAddressViewObject;
import SaveCheckoutB2BWebRequest = Vertica.LouisPoulsen.Application.Commerce.Requests.Business.SaveCheckoutB2BWebRequest;
import { BasketType } from '@/enums';
import ConfirmationModal from '@/ui/shared/ConfirmationModal.vue';
import { computed, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BasketB2B',
  props: {
    model: null
  },
  setup(__props: any) {

const props = __props as { model: BasketPageViewModel }

const basketB2B = computed<BasketViewModel>(() => store.getters['basket/basketB2B']);
const logoutUrl = computed<string>(() => store.getters['app/logoutUrl']);

function fetchBasket() {
    store.dispatch('basket/fetchBasket');
}
function updateOrderReference(request: UpdateOrderReferenceWebRequest) {
    store.dispatch('basket/updateOrderReference', request);
}
function updateOrderDeliveryType(request: UpdateOrderDeliveryTypeWebRequest) {
    store.dispatch('basket/updateOrderDeliveryType', request);
}
function updatePaymentMethod(request: UpdatePaymentMethodWebRequest) {
    store.dispatch('basket/updatePaymentMethod', request);
}
function updateOrderDeliveryDate(request: UpdateOrderDeliveryDateWebRequest) {
    store.dispatch('basket/updateOrderDeliveryDate', request);
}
function ensureValidForCheckout() : Promise<ValidationResultViewModel> {
    return store.dispatch('basket/ensureValidForCheckout');
}
function submitOrder(request: SaveCheckoutB2BWebRequest) : Promise<SaveCheckoutViewModel> {
    return store.dispatch('checkoutb2b/submitOrder', request);
}



const customDeliveryAddress = ref<CustomDeliveryAddressViewObject>(props.model.customDeliveryAddress);
const selectedDeliveryAddressId = ref<string>(props.model.deliveryAddressId);

const firstDeliveryDate = computed<Date>(() => {
    return parse(props.model.firstDeliveryDate, internalDateFormat, new Date());
});
const lastDeliveryDate = computed<Date>(() => {
    return parse(props.model.lastDeliveryDate, internalDateFormat, new Date());
});
const deliveryDate = computed<Date>(() => {
    const date = basketB2B.value.orderDeliveryDate;

    if (date < firstDeliveryDate.value || date > lastDeliveryDate.value) { return null; }

    return basketB2B.value.orderDeliveryDate;
});
const basketHasItems = computed<boolean>(() => {
    const lineItemCount = basketB2B.value.lineItems.length;
    return lineItemCount !== 0;
});
const isCustomDeliveryAddressSelected = computed<boolean>(() => {
    // Selectable delivery addresses has an id, which will be set in "selectedDeliveryAddressId" if selected. The only delivery address that doesn't have an id is custom delivery address which has an empty string
    return selectedDeliveryAddressId.value === '';
});

const confirmationModal = ref(null);

fetchBasket();

function onOrderReferenceChange(texts: any) {
    const request : UpdateOrderReferenceWebRequest = {
        orderReference: texts.reference,
        customerReference: null,
        orderComment: texts.comment,
        basketType: BasketType.B2B as any
    };
    updateOrderReference(request);
}

function onPaymentMethodChange(paymentMethod: string) {
    const paymentMethodId : number = parseInt(paymentMethod, 10);

    const request : UpdatePaymentMethodWebRequest = {
        paymentMethodType: paymentMethodId
    };

    updatePaymentMethod(request);
}

function onDeliveryTypeChange(deliveryType: string) {
    const deliveryTypeNumber: number = parseInt(deliveryType, 10);

    const request : UpdateOrderDeliveryTypeWebRequest = {
        deliveryType: deliveryTypeNumber
    };

    updateOrderDeliveryType(request);
}

function onDeliveryDateChange(deliveryDate: string) {
    const isDeliveryDateEmpty = deliveryDate === '';
    if (isDeliveryDateEmpty) { return; }

    const request : UpdateOrderDeliveryDateWebRequest = {
        deliveryDate
    };

    updateOrderDeliveryDate(request);
}

async function onSubmit() {
    if (isCustomDeliveryAddressSelected.value) {
        const customAddressIsConfirmed: boolean = await confirmationModal.value.confirm().then(() => {
            return true;
        }).catch(() => {
            return false;
        });
        if (!customAddressIsConfirmed) {
            return;
        }
    }

    if (document.activeElement) {
        const input = (document.activeElement as HTMLInputElement);
        if (input.type === 'text') {
            input.blur();
            return false;
        }
    }

    showSpinner.value = true;
    validationMessage.value = null;
    await ensureValidForCheckout().then((response : ValidationResultViewModel) => {
        if (!response.isValid) {
            validationMessage.value = response.message;
        } else {
            submitOrder(orderRequest.value).then(response => {
                if (response.isValid) {
                    window.location.href = response.redirectUrl;
                } else if (response.message) {
                    validationMessage.value = response.message.value;
                }
            });
        }
    }).catch(() => {
        validationMessage.value = 'unknown error';
    }).finally(() => {
        showSpinner.value = false;
    });
}

const orderRequest = computed<SaveCheckoutB2BWebRequest>(() => {
    return {
        basketType: BasketType.B2B as any,
        customDeliveryAddress: isCustomDeliveryAddressSelected.value ? customDeliveryAddress.value : null,
        deliveryAddressId: selectedDeliveryAddressId.value
    };
});

const showSpinner = ref<boolean>(false);
const validationMessage = ref<any>(null);
const siteMode = SiteMode;

return { __sfc: true,basketB2B, logoutUrl, fetchBasket, updateOrderReference, updateOrderDeliveryType, updatePaymentMethod, updateOrderDeliveryDate, ensureValidForCheckout, submitOrder, props, customDeliveryAddress, selectedDeliveryAddressId, firstDeliveryDate, lastDeliveryDate, deliveryDate, basketHasItems, isCustomDeliveryAddressSelected, confirmationModal, onOrderReferenceChange, onPaymentMethodChange, onDeliveryTypeChange, onDeliveryDateChange, onSubmit, orderRequest, showSpinner, validationMessage, siteMode, BasketEmpty, BasketSummaryB2B, BasketOrderReferenceB2B, BasketDeliveryTypeB2B, PaymentMethodsB2B, CheckoutButtonB2B, BasketLineItemsB2B, BasketTitle, BasketAddressSelectorB2B, ConfirmationModal }
}

})